module.exports = __webpack_public_path__ + "static/perspective-4761e814456a3c72fa5e4b4ad1091b23.jpg";